import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button, FoodsIcon } from "@foodpilot/foods";
import { CREATE, PACKAGING, useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { URLHandler } from "src/services/URLHandler";
import { useState } from "react";
import { PackagingCreateChoiceModal } from "./PackagingCreateChoiceModal";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const PackagingCreate = () => {
    const { t } = useTranslation();
    const { canUser, selectedCompany } = useFoodpilotContext();
    const navigate = useNavigate();
    const [showCreateChoice, setShowCreateChoice] = useState(false);
    const isProductUxV2 = useIsProductUxV2();

    if (!canUser(CREATE, PACKAGING) || selectedCompany === null) return null;

    return (
        <>
            <Button
                variant="primary"
                startIcon={isProductUxV2 ? <FoodsIcon icon="plus" size={2} /> : undefined}
                onClick={() => setShowCreateChoice(true)}
            >
                {t("packagings.create.new")}
            </Button>
            <PackagingCreateChoiceModal
                appearance={isProductUxV2 ? "product-v2" : "legacy"}
                open={showCreateChoice}
                onClose={() => setShowCreateChoice(false)}
                onSelectElement={() => navigate(URLHandler.packaging.createElement(selectedCompany.id))}
                onSelectComposite={() => navigate(URLHandler.packaging.createComposite(selectedCompany.id))}
            />
        </>
    );
};
